import { useRef, useState } from "react"
import { Trans } from "@lingui/react/macro"
import { ContactAssigneesCell } from "./contact-assignees-cell"
import { ReassignContactAssignees } from "./reassign-contact-assignees"
import { replaceContactProp, type ContactPropKey } from "@/lib/contact-prop-update"
import type { ContactAssignee } from "@/types/v2/contact"

// Properties-card "Owner" row for the contact show page and
// both slideovers. Renders the label + avatar stack / "Assign
// →" trigger, and manages the reassign popover / sheet state.
// Writes optimistic updates back via replaceContactProp so
// browser back/forward sees the updated state.
export function ContactAssigneesRow({
  contactId,
  contactName,
  assignees,
  contactPropKey,
}: {
  contactId: number
  contactName: string
  assignees: ContactAssignee[]
  contactPropKey: ContactPropKey
}) {
  const [open, setOpen] = useState(false)
  const triggerRef = useRef<HTMLDivElement>(null)

  function apply(updated: ContactAssignee[]) {
    replaceContactProp(contactPropKey, (prev) => ({
      ...prev,
      assignees: updated,
    }))
  }

  return (
    <>
      <div className="flex items-center py-3 px-4 gap-3">
        <span className="grow-0 shrink-0 text-[#7A746B] text-[13px] leading-4">
          <Trans>Owner</Trans>
        </span>
        <div
          ref={triggerRef}
          className="grow basis-0 min-w-0 flex justify-end items-center gap-1.5"
        >
          <ContactAssigneesCell
            assignees={assignees}
            onReassign={() => setOpen(true)}
          />
        </div>
      </div>
      <ReassignContactAssignees
        open={open}
        onClose={() => setOpen(false)}
        triggerRef={triggerRef}
        contactId={contactId}
        contactName={contactName}
        assignees={assignees}
        applyOptimistic={apply}
      />
    </>
  )
}
